import { render, staticRenderFns } from "./OxygenControlName.vue?vue&type=template&id=c331a950&scoped=true&"
import script from "./OxygenControlName.vue?vue&type=script&lang=ts&"
export * from "./OxygenControlName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c331a950",
  null
  
)

export default component.exports